import { Controller } from '@hotwired/stimulus';
import { getViewport, debounce } from './util';

export default class extends Controller {
    static targets = ['video'];

    landscape = {
        2560: '2560x1440',
    };

    portrait = {
        1080: '720x1280-v2',
    };
    connect() {
        this.videoName = null;
        this.fileName = null;
        window.addEventListener('resize', debounce(this.init.bind(this)));
        this.init();
    }

    disconnect() {
        window.removeEventListener('resize', debounce(this.init.bind(this)));
    }

    init() {
        if (!window) {
            return;
        }
        const { w, h } = getViewport(window);
        let videoName = this.element.dataset.videoName;
        videoName = w > h ? videoName : videoName + '_portrait';
        const config = w > h ? this.landscape : this.portrait;
        let fileName = false;
        Object.keys(config).forEach((key, i) => {
            if (
                !fileName &&
                (key > w || i === Object.keys(config).length - 1)
            ) {
                fileName = config[key];
            }
        });

        if (this.videoName !== videoName || this.fileName !== fileName) {
            this.videoTarget.poster = this.getVideoPoster(videoName, fileName);
            this.videoTarget.src = this.getCroppedSource(videoName, fileName);
        }
    }

    getVideoPoster(videoName, fileName) {
        return `/assets/video/${videoName}/segmented/${fileName}/poster.jpg`;
    }

    getCroppedSource(videoName, fileName) {
        return `/assets/video/${videoName}/cropped/${fileName}.mp4?v=1`;
    }
}
